import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { metadataApi } from './metadataApi';

/**
 * Визначення типу запису разом із модулем (GET /meta/record-types/{key}) — злите з налаштуваннями поточного простору маршруту (ADR-023):
 * пошук посилань, швидке створення, підписи статусів чужих типів бачать те саме визначення, що й сторінки модулів цього простору.
 */
export function useGetRecordTypeQuery(key: string, options?: { skip?: boolean }) {
  const { ws } = useWorkspaceParams();
  return metadataApi.endpoints.getRecordType.useQuery({ key, workspaceId: ws || undefined }, options);
}
